// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createVerticalSmallHeadingAndTextStyles } from "@sc/App/SharedStyles/smallHeadingAndTextStyles";
import { headerStyles } from "@sc/Overrides/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationHeader";
import { css } from "styled-components";

headerStyles.titleText = {
    css: css`
        margin-bottom: 24px;
    `,
};
headerStyles.orderNumberText = {
    css: css`
        margin-bottom: 16px;
    `,
};
headerStyles.headingAndTextStyles = {
    ...createVerticalSmallHeadingAndTextStyles({
        wrapper: {
            css: css`
                justify-content: flex-end;
                gap: 12px;
                margin-bottom: 24px;
            `,
        },
        heading: {
            size: 14,
            weight: "bold",
            css: css`
                line-height: 19px;
            `,
        },
        text: {
            size: 14,
            weight: "normal",
            css: css`
                line-height: 22px;
            `,
        },
    }),
};
headerStyles.customMsg = {
    forwardAs: "p",
    lineHeight: "22px",
    weight: "normal",
    size: 14,
    css: css`
        margin-bottom: 0;
    `,
};
headerStyles.requiresApprovalMsg = {
    forwardAs: "p",
    lineHeight: "22px",
    weight: "normal",
    size: 14,
    css: css`
        margin-bottom: 16px;
    `,
};
